import add from './add';

export const externalCpd = {
  add
}


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/testing-portal/pressure-test/config/endpoints/external-cpd/index.js